"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpTopMenu = void 0;
const gs_1 = require("@ivanlog/gs");
const gs = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const StateSearch_1 = require("../../appProfiMall/states/StateSearch");
const Helper_1 = require("../Helper");
const ClassesTags_1 = require("../ClassesTags");
const StateProfile_1 = require("../../appProfiMall/states/StateProfile");
class CmpTopMenu extends tmpls_1.CmpTopMenuBase {
    constructor() {
        super();
        const ctrl = this.ctrls;
        ctrl.blockAbout.onclick = () => { ctrl.blockAbout.flipClass(ClassesTags_1.ClassesTags.Toggled); ctrl.blockClient.removeClass(ClassesTags_1.ClassesTags.Toggled); };
        ctrl.blockClient.onclick = () => { ctrl.blockClient.flipClass(ClassesTags_1.ClassesTags.Toggled); ctrl.blockAbout.removeClass(ClassesTags_1.ClassesTags.Toggled); };
        const catalog_opened = "catalog_opened";
        ctrl.btnCatalog.onclick = () => this.flipClass(catalog_opened);
        ctrl.btnProfile.addClass(gs_1.StateGS.LinkCatchedClassName); //вешаем, чтобы фреймворк не перехватывал
        ctrl.btnProfile.onclick = (e) => {
            gs.events.stop(e);
            if (!App_1.App.Inst.auth.user) {
                App_1.App.Inst.auth.authAsync((result) => {
                    if (!result)
                        return;
                    gs.StateGS.Run(StateProfile_1.StateProfile);
                    return;
                });
            }
            else
                gs.StateGS.Run(StateProfile_1.StateProfile);
        };
        App_1.App.Inst.gui.onChangePage.addHandler(() => {
            ctrl.blockAbout.removeClass(ClassesTags_1.ClassesTags.Toggled);
            ctrl.blockClient.removeClass(ClassesTags_1.ClassesTags.Toggled);
            this.removeClass(catalog_opened);
            this.ctrls.iSearchQuery.value = '';
            ctrl.btnSearch.hide();
            ctrl.btnResetInput.hide();
        });
        ctrl.btnSearch.onclick = () => this._trySearchAsync();
        ctrl.btnResetInput.onclick = () => {
            ctrl.iSearchQuery.value = "";
            ctrl.btnSearch.hide();
            ctrl.btnResetInput.hide();
        };
        ctrl.iSearchQuery.el.onfocus =
            ctrl.iSearchQuery.el.oninput = () => {
                if (ctrl.iSearchQuery.value != "") {
                    ctrl.btnSearch.show();
                    ctrl.btnResetInput.show();
                }
                else {
                    ctrl.btnSearch.hide();
                    ctrl.btnResetInput.hide();
                }
            };
        Helper_1.Helper.addEnterPressEvent(ctrl.iSearchQuery.el, () => this._trySearchAsync());
    }
    _trySearchAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const value = this.ctrls.iSearchQuery.value;
            if (!value)
                return;
            if (gs_1.StateGS.ActiveState && gs_1.StateGS.ActiveState.name == StateSearch_1.StateSearch.StateName) {
                gs_1.StateGS.ActiveState.search(value);
                return;
            }
            gs_1.StateGS.Run(StateSearch_1.StateSearch, { query: value });
        });
    }
}
exports.CmpTopMenu = CmpTopMenu;
//# sourceMappingURL=CmpTopMenu.js.map